<script>
import { mapState } from "vuex";
export default {
  props: { ativar: Boolean },
  data () {
    return {
    }
  },
  computed: { 
    ...mapState({
      alerta: state => state.moduleAlerta.alerta,
    }),
    
  },
  methods: {
    mudadoDataInicial () {
      this.alerta.optionsDataFinal.minDate = this.alerta.dataInicial
    },
  }    
}
</script>

<template>
  <div>
    <b-form-text>Inicio:</b-form-text>
    <b-form-datepicker class="mb-2 shadow rounded" placeholder="Data Inicial" v-model="alerta.dataInicial" :date-format-options="alerta.optionsDataInicial" @context="mudadoDataInicial" 
                       :max="new Date()" :min="new Date(new Date().getFullYear()-2, new Date().getMonth(), new Date().getDate())" :disabled='ativar'/>
  </div>
</template>

<style>

</style>